module.exports = __webpack_public_path__ + "static/media/belt-blue.ff84ed93.png";